<div class="modal-header">
    <h5 class="mb-0">{{ title | translate }}</h5>
    <h5 *ngIf="itemName" class="mb-0">&nbsp;-&nbsp;<b>{{ itemName }}</b></h5>
</div>
<div class="modal-body">
    <p class="fw-bold">
        <i class="bi bi-exclamation-circle"></i> {{confirmMessage | translate }}
    </p>
</div>
<div class="modal-footer">
    <button id="confirmButton" class="btn {{acceptStyleClass}}" (click)="onAccept($event)">{{ 'common.confirm' | translate }}</button>
    <button id="cancelButton" class="btn btn-secondary" (click)="onCancel($event)">{{ 'common.cancel' | translate }}</button>
</div>
